import { Ordering } from '@/types/graphql';
import { queuesForVariation } from '@axle-health/work-queue-definitions';

import { defaultVisitsRowToLink } from '../definitions';
import { definitionFor, fromDefinition } from '../fromDefinition';
import { ShiftBlockDashboardContainer, VisitDashboardContainer } from '../types';
import { TELADOC_CONTAINER_KEYS } from './containerKeys/containerKeys';
import { IDashboardVariationConfig } from './types';

const PUBLISHED_QUEUES = queuesForVariation('TELADOC');

const UNASSIGNED_CONTAINER: VisitDashboardContainer = fromDefinition(
    definitionFor(PUBLISHED_QUEUES, TELADOC_CONTAINER_KEYS.unassigned),
    {
        defaultEnabled: true,
        hoverText: 'Visits in need of a clinician assignment.',
        tableConfig: {
            rowToLink: defaultVisitsRowToLink,
            emptyTableText: 'No unassigned visits at this time',
            ordering: { startDatetime: Ordering.ASC },
        },
    },
);

const SHIFT_BLOCK_SYNC_ISSUES_CONTAINER: ShiftBlockDashboardContainer = fromDefinition(
    definitionFor(PUBLISHED_QUEUES, TELADOC_CONTAINER_KEYS.shiftBlockSyncIssues),
    {
        defaultEnabled: true,
        hoverText: 'Shift blocks that failed to sync to the external calendar system.',
        tableConfig: {
            rowToLink: null,
            emptyTableText: 'No shift block sync issues at this time.',
            ordering: { startDatetime: Ordering.DESC },
        },
    },
);

export const TELADOC_DASHBOARD_CONFIG: IDashboardVariationConfig = {
    containers: [UNASSIGNED_CONTAINER, SHIFT_BLOCK_SYNC_ISSUES_CONTAINER],
};
